import React from "react";

export default function SkeletonCard() {
  const lineAmount = Math.floor(Math.random() * 3);
  return (
    <div className="col-12">
      <div className="search-listing skeleton">
        <div className="main">
          <h3></h3>
          {[...Array(lineAmount)].map((e, i) => (
            <p
              key={i}
              className="teaser"
              style={{ width: `${Math.floor(Math.random() * 100)}%` }}
            ></p>
          ))}
        </div>
        <p className="btn-primary"></p>
      </div>
    </div>
  );
}
